import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.values";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import Vue from 'vue';
import VueApollo from 'vue-apollo';
import 'cross-fetch/polyfill';
import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client';
import Cookie from 'universal-cookie';
import { InMemoryCache } from 'apollo-cache-inmemory';
Vue.use(VueApollo);
export default (function (ctx, inject) {
  var providerOptions = {
    clients: {}
  };
  var app = ctx.app,
      beforeNuxtRender = ctx.beforeNuxtRender,
      req = ctx.req;
  var AUTH_TOKEN_NAME = 'apollo-token';
  var COOKIE_ATTRIBUTES = {
    "expires": 7,
    "path": "/",
    "secure": false
  };
  var AUTH_TYPE = 'Bearer ';
  var cookies = new Cookie(req && req.headers.cookie); // Config

  var defaultTokenName = '' || AUTH_TOKEN_NAME;

  function defaultGetAuth() {
    var token = cookies.get(defaultTokenName);
    return token && defaultClientConfig.validateToken(token) ? AUTH_TYPE + token : '';
  }

  var defaultClientConfig;
  defaultClientConfig = require('~/plugins/apollo-config');

  if ('default' in defaultClientConfig) {
    defaultClientConfig = defaultClientConfig.default;
  }

  defaultClientConfig = defaultClientConfig(ctx);

  var defaultValidateToken = function defaultValidateToken() {
    return true;
  };

  if (!defaultClientConfig.validateToken) {
    defaultClientConfig.validateToken = defaultValidateToken;
  }

  var defaultCache = defaultClientConfig.cache ? defaultClientConfig.cache : new InMemoryCache(defaultClientConfig.inMemoryCacheOptions ? defaultClientConfig.inMemoryCacheOptions : undefined);

  if (!process.server) {
    defaultCache.restore(window.__NUXT__ ? window.__NUXT__.apollo.defaultClient : null);
  }

  if (!defaultClientConfig.getAuth) {
    defaultClientConfig.getAuth = defaultGetAuth;
  }

  if (process.client && defaultClientConfig.browserHttpEndpoint) {
    defaultClientConfig.httpEndpoint = defaultClientConfig.browserHttpEndpoint;
  }

  defaultClientConfig.ssr = !!process.server;
  defaultClientConfig.cache = defaultCache;
  defaultClientConfig.tokenName = defaultTokenName; // if ssr we'd still like to have our webclient's cookies

  if (process.server && req && req.headers && req.headers.cookie) {
    if (!defaultClientConfig.httpLinkOptions) {
      defaultClientConfig.httpLinkOptions = {};
    }

    if (!defaultClientConfig.httpLinkOptions.headers) {
      defaultClientConfig.httpLinkOptions.headers = {};
    }

    defaultClientConfig.httpLinkOptions.headers.cookie = req.headers.cookie;
  } // Create apollo client


  var defaultApolloCreation = createApolloClient(_objectSpread({}, defaultClientConfig));
  defaultApolloCreation.apolloClient.wsClient = defaultApolloCreation.wsClient;
  providerOptions.defaultClient = defaultApolloCreation.apolloClient;
  var vueApolloOptions = Object.assign(providerOptions, {
    errorHandler: function errorHandler(error) {
      console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message);
    }
  });
  var apolloProvider = new VueApollo(vueApolloOptions); // Allow access to the provider in the context

  app.apolloProvider = apolloProvider;

  if (process.server) {
    var ApolloSSR = require('vue-apollo/ssr');

    beforeNuxtRender(function (_ref) {
      var nuxtState = _ref.nuxtState;
      nuxtState.apollo = ApolloSSR.getStates(apolloProvider); // Clear apollo client cache after each request
      // Issues: https://github.com/nuxt-community/apollo-module/issues/273
      //         https://github.com/nuxt-community/apollo-module/issues/251

      Object.values(apolloProvider.clients).forEach(function (client) {
        return client.cache.reset();
      });
    });
  }

  inject('apolloHelpers', {
    onLogin: function () {
      var _onLogin = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(token) {
        var apolloClient,
            cookieAttributes,
            skipResetStore,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apolloClient = _args.length > 1 && _args[1] !== undefined ? _args[1] : apolloProvider.defaultClient;
                cookieAttributes = _args.length > 2 && _args[2] !== undefined ? _args[2] : COOKIE_ATTRIBUTES;
                skipResetStore = _args.length > 3 && _args[3] !== undefined ? _args[3] : false;
                // Fallback for tokenExpires param
                if (typeof cookieAttributes === 'number') cookieAttributes = {
                  expires: cookieAttributes
                };

                if (typeof cookieAttributes.expires === 'number') {
                  cookieAttributes.expires = new Date(Date.now() + 86400 * 1000 * cookieAttributes.expires);
                }

                if (token) {
                  cookies.set(AUTH_TOKEN_NAME, token, cookieAttributes);
                } else {
                  cookies.remove(AUTH_TOKEN_NAME, cookieAttributes);
                }

                if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);

                if (skipResetStore) {
                  _context.next = 16;
                  break;
                }

                _context.prev = 8;
                _context.next = 11;
                return apolloClient.resetStore();

              case 11:
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](8);
                // eslint-disable-next-line no-console
                console.log('%cError on cache reset (setToken)', 'color: orange;', _context.t0.message);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[8, 13]]);
      }));

      function onLogin(_x) {
        return _onLogin.apply(this, arguments);
      }

      return onLogin;
    }(),
    onLogout: function () {
      var _onLogout = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var apolloClient,
            skipResetStore,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                apolloClient = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : apolloProvider.defaultClient;
                skipResetStore = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
                cookies.remove(AUTH_TOKEN_NAME, COOKIE_ATTRIBUTES);
                if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);

                if (skipResetStore) {
                  _context2.next = 13;
                  break;
                }

                _context2.prev = 5;
                _context2.next = 8;
                return apolloClient.resetStore();

              case 8:
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](5);
                // eslint-disable-next-line no-console
                console.log('%cError on cache reset (logout)', 'color: orange;', _context2.t0.message);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[5, 10]]);
      }));

      function onLogout() {
        return _onLogout.apply(this, arguments);
      }

      return onLogout;
    }(),
    getToken: function getToken() {
      var tokenName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : AUTH_TOKEN_NAME;
      return cookies.get(tokenName);
    }
  });
});